import { createButton } from '../Button/index.js';
import { typingTestService } from '../../services/TypingTestService.js';

export const createTypingTestWidget = () => {
    const container = document.createElement('div');
    container.className = 'cm-typing-widget';

    container.innerHTML = `
    <div class="cm-typing-header">
      <div class="cm-typing-title">TYPING SPEED TEST_WPM</div>
      <div class="cm-typing-stats">
        <div class="cm-typing-stat">WPM: <span id="wpm-display">0</span></div>
        <div class="cm-typing-stat">ACC: <span id="acc-display">100%</span></div>
      </div>
    </div>
    <div class="cm-typing-display" id="typing-text-display">
      <!-- Text will be rendered here -->
    </div>
    <div class="cm-typing-controls">
      <div id="typing-status" class="cm-typing-status">TYPING_IDLE</div>
    </div>
  `;

    const textDisplay = container.querySelector('#typing-text-display');
    const wpmDisplay = container.querySelector('#wpm-display');
    const accDisplay = container.querySelector('#acc-display');
    const statusDisplay = container.querySelector('#typing-status');
    const controlsDiv = container.querySelector('.cm-typing-controls');

    const resetBtn = createButton({ label: 'RESTART_TEST', type: 'outline', onClick: () => typingTestService.reset() });
    controlsDiv.appendChild(resetBtn);

    const renderText = (results) => {
        textDisplay.innerHTML = '';
        const { text, input } = results;

        for (let i = 0; i < text.length; i++) {
            const span = document.createElement('span');
            span.textContent = text[i];
            span.className = 'cm-typing-char';

            if (i < input.length) {
                if (input[i] === text[i]) {
                    span.classList.add('cm-typing-char--correct');
                } else {
                    span.classList.add('cm-typing-char--error');
                }
            } else if (i === input.length && results.isActive) {
                span.classList.add('cm-typing-char--current');
            } else {
                span.classList.add('cm-typing-char--pending');
            }

            textDisplay.appendChild(span);
        }
    };

    const updateStats = (results) => {
        wpmDisplay.textContent = results.wpm;
        accDisplay.textContent = `${results.accuracy}%`;

        if (results.isActive) {
            statusDisplay.textContent = 'TEST_IN_PROGRESS';
            statusDisplay.style.color = 'var(--color-primary)';
        } else if (results.input.length === results.text.length && results.input === results.text) {
            statusDisplay.textContent = `TEST_COMPLETE: ${results.wpm} WPM / ${results.accuracy}% ACC`;
            statusDisplay.style.color = '#fff';
        } else {
            statusDisplay.textContent = 'TYPING_IDLE (START TYPING)';
            statusDisplay.style.color = 'var(--color-text-dim)';
        }
    };

    typingTestService.addEventListener('teststart', () => {
        updateStats(typingTestService.getResults());
        renderText(typingTestService.getResults());
    });

    typingTestService.addEventListener('testupdate', (e) => {
        updateStats(e.detail);
        renderText(e.detail);
    });

    typingTestService.addEventListener('testcomplete', (e) => {
        updateStats(e.detail);
        renderText(e.detail);
    });

    typingTestService.addEventListener('testreset', () => {
        updateStats({ isActive: false, text: typingTestService.testText, input: "", wpm: 0, accuracy: 100 });
        renderText({ isActive: false, text: typingTestService.testText, input: "" });
    });

    // Initial render setup
    renderText({ isActive: false, text: typingTestService.testText, input: "" });

    return container;
};
